import { useQuery } from "@tanstack/react-query";
import type { AuthSession } from "../../auth/keycloak.js";
import { manualApi } from "../../api/client.js";

/**
 * The manuals the caller is an ASSIGNED REVIEWER of, as ids (`GET /user/manual-assignments`) — the
 * "Assigned to me" advanced filter (ADR-019 Phase 4, read half). The same idea as {@link useManualFavorites}'s set:
 * the facility list is already loaded, so membership is all the filter needs. Permission-filtered server-side to
 * directly-viewable manuals. Keyed per tenant + subject; the assign/unassign mutations invalidate it.
 */
export function useMyManualAssignments(session: AuthSession | null) {
  return useQuery({
    queryKey: ["manual-assignments", session?.realm, session?.sub],
    enabled: session !== null,
    // A plain `number[]`, NOT a Set: React Query's structural sharing keeps the reference stable across a background
    // refetch only for JSON arrays/objects, and the view's `filtered` memo hangs off this reference — a fresh Set per
    // window-focus refetch recomputed the whole list for nothing (diff-panel). The Set is derived downstream.
    queryFn: async (): Promise<number[]> => {
      const res = await manualApi.listMyManualAssignments();
      if (res.status !== 200) throw new Error(`GET /user/manual-assignments returned ${res.status}`);
      return res.body.manuals;
    },
  });
}
